// src/components/GlobalMessageBridge.jsx
import { useEffect } from "react";
import { useModemViewer } from "../context/ModemViewerContext";
import { useReclamoModal } from "../context/ReclamoModalContext";

export default function GlobalMessageBridge() {
  const { openModemViewer } = useModemViewer();
  const { openReclamo } = useReclamoModal();

  useEffect(() => {
    function handler(event) {
      const data = event.data;
      // opcional: validar event.origin
      if (data?.type === "OPEN_MODEM" && data?.payload) {
        // 👇 aquí ya abrimos el modal real
        openModemViewer(data.payload);
      }
      if (data?.type === "OPEN_RECLAMO" && data?.payload) {
        // payload = placa
        openReclamo(data.payload, { placa: data.payload });
      }
    }

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [openModemViewer, openReclamo]);

  return null; // no muestra nada
}
